import { useState } from 'react';
import { Control, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { makeStyles } from '@material-ui/core';

import TabsController from '../../../shared/components/Tabs/ButtonTabsController';
import { ContactSearchTable } from '../../../users/components/Tables/ContactSearchTable.component';
import { User } from '../../../users/types/user.type';
import { CreateOrganizationFormValues } from './create-organization-form.type';
import { NewContactForm } from './NewContactForm.component';

type ContactTabId = 'existing' | 'new';

type Props = {
  control: Control<CreateOrganizationFormValues>;
  watch: UseFormWatch<CreateOrganizationFormValues>;
  setValue: UseFormSetValue<CreateOrganizationFormValues>;
};

const TABS: { id: ContactTabId; label: string; value: ContactTabId }[] = [
  { id: 'existing', label: 'Existant', value: 'existing' },
  { id: 'new', label: 'Nouveau', value: 'new' },
];

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
  },
});

export function ContactStep({ control, watch, setValue }: Props) {
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState<ContactTabId>(watch('contactMode') ?? 'existing');
  const selectedContact = watch('selectedContact');

  const handleTabChange = (next: string) => {
    const nextTab = next as ContactTabId;
    setActiveTab(nextTab);
    setValue('contactMode', nextTab, { shouldValidate: true });
  };

  const handleSelectContact = (user: User) => {
    setValue('selectedContact', user, { shouldValidate: true });
  };

  return (
    <section className={classes.root}>
      <TabsController tabs={TABS} currentTabId={activeTab} onTabChange={handleTabChange} />
      {activeTab === 'existing' ? (
        <ContactSearchTable selectedContactId={selectedContact?.id ?? null} onSelectContact={handleSelectContact} />
      ) : (
        <NewContactForm control={control} />
      )}
    </section>
  );
}
